import { render } from "./EventInput.vue?vue&type=template&id=cab5c198&scoped=true"
import script from "./EventInput.vue?vue&type=script&lang=js"
export * from "./EventInput.vue?vue&type=script&lang=js"

import "./EventInput.vue?vue&type=style&index=0&id=cab5c198&scoped=true&lang=scss"

import exportComponent from "/usr/share/nginx/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cab5c198"]])

export default __exports__